import { colors } from '../../colors';
var address = {
  addressColor: colors.darkNight
};
export default address;